<template lang="pug">
v-app(light)
  router-view

  ConfirmationDialog(ref='confirm')

  ChoiceDialog(ref='choice')

  Snackbar(ref='snackbar')

  Save(ref='save')
</template>

<script>
import ConfirmationDialog from './components/ConfirmationDialog'
import ChoiceDialog from './components/ChoiceDialog'
import Snackbar from './components/Snackbar'
import Save from './components/Save'
import swal from 'sweetalert2'

export default {
  components: {
    ConfirmationDialog,
    ChoiceDialog,
    Snackbar,
    Save
  },

  mounted () {
    // Set up global helpers
    this.$root.$confirm = this.$refs.confirm.open
    this.$root.$choice = this.$refs.choice.open
    this.$root.$snackbar = this.$refs.snackbar
    this.$root.$save = this.$refs.save
    this.$root.$swal = function (args) {
      swal.mixin({
        customClass: 'v-dialog',
        confirmButtonClass: 'v-btn theme--light primary'
      })(args)
    }
  }
}
</script>

<style lang="stylus">
// See https://github.com/vuetifyjs/vuetify/blob/master/packages/vuetify/src/stylus/settings/_variables.styl
@import '~vuetify/src/stylus/settings/_variables';

$border-radius = 4px;
$button-border-radius = $border-radius;
$alert-border-radius = $border-radius;
$card-border-radius = $border-radius;

@import '~vuetify/src/stylus/main';
</style>

<style lang="scss">
@import "./styles/scrollbar";
@import "./styles/vuetify";
@import "./styles/fonts";
@import "./styles/layout";
@import "./styles/variables";
@import "./styles/transition";
@import "./styles/sweetalert";
@import "./styles/custom";
@import "dealerfinanceservices-shared/src/styles/components.scss";
@import "~vue-wysiwyg/dist/vueWysiwyg.css";

.application {
  background-color: white !important;
}

aside {
  background-color: $dark !important;
}
</style>
